import request from '../request'

export function docList(base, query) {
  return request.post(base + '/list', {
    currentPage: query.pageIndex,
    pageSize: query.pageSize,
    code: query.code,
    partnerName: query.partnerName,
    partnerId: query.partnerId,
    status: query.status,
    dateFrom: query.dateFrom,
    dateTo: query.dateTo
  })
}

export function docInfo(base, id) {
  return request.get(`${base}/info/${id}`)
}

export function docSave(base, data, idKey) {
  return request.post(base + (data[idKey] ? '/update' : '/save'), data)
}

export function docAction(base, action, body) {
  return request.post(base + '/' + action, body || {})
}

export function docGet(url, params) {
  return request.get(url, { params })
}

export function docBlob(base, action, body) {
  return request.post(base + '/' + action, body || {}, { responseType: 'blob' })
}
